// test794
(794 && 0);
